module.exports = __webpack_public_path__ + "static/media/anim_intro_minicov_text.bd5dc2e0.gif";